import { CategoryId } from "../../../domain/disease_knowledge/DiseaseCategory";
import { ApiPaths } from "../../api/ApiPaths";
import { ApiRequest } from "../../api/ApiRequest";

export type GetListJson = {
    diseaseCategories: {
        id: CategoryId,
        name: string,
        diseases: {
            id: string,
            name: string
        }[]
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getDiseaseList(): Promise<GetListJson> {
    return await ApiRequest.get(
        ApiPaths.diseaseKnowledge.list,
        {},
        () => {},
        () => {});
}

export type GetJson = {
    disease: {
        id: string,
        name: string,
        category: {
            id: CategoryId,
            name: string
        },
        description: string,
        abstractDiseases: string[],
        symptoms: string[],
        misleadingDiseases: string[],
        watch: {
            medicines: string[],
            meals: string[],
            lifestyleAndEnvironments: string[],
            carestaffs: string[],
            others: string[]
        },
        assessmentCheckpoint: {
            activities: string[],
            environments: string[],
            impairments: string[],
            participations: string[],
            personals: string[]
        },
        suggestingServices: {
            title: string,
            detail: string
        }[],
        advices: string[]
    },
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getInfo(
    diseaseId: string
): Promise<GetJson> {
    return await ApiRequest.get(
        ApiPaths.diseaseKnowledge.info,
        {
            disease_id: diseaseId
        },
        () => {},
        () => {});
}

export type LookupJson = {
    extractedDiseases: {
        id: string,
        name: string,
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function lookup(
    diseaseNames: string[]
): Promise<LookupJson> {
    return await ApiRequest.get(
        ApiPaths.diseaseKnowledge.lookup,
        {
            disease_name: diseaseNames
        },
        () => {},
        () => {});
}

export type SearchJson = {
    searchedDiseases: {
        id: string,
        name: string,
        category: {
            id: CategoryId,
            name: string
        },
        symptoms: string[]
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function search(
    keyword: string
): Promise<SearchJson> {
    return await ApiRequest.get(
        ApiPaths.diseaseKnowledge.search,
        {
            keyword: keyword
        },
        () => {},
        () => {});
}
